import IcPower from "@/assets/2024/icons/facilities/power.png";
import IcSound from "@/assets/2024/icons/facilities/sound.png";
import IcPresentation from "@/assets/2024/icons/facilities/presentatin.png";
import IcStageFloor from "@/assets/2024/icons/facilities/stage-floor-panel.png";
import IcFreeParking from "@/assets/2024/icons/facilities/parking.png";
import IcSwimmingPool from "@/assets/2024/icons/facilities/swimming-pool.png";
import IcGym from "@/assets/2024/icons/facilities/gym.png";
import IcLoadingArea from "@/assets/2024/icons/facilities/loading-area.png";
import IcLobby from "@/assets/2024/icons/facilities/lobby.png";
import IcWifi from "@/assets/2024/icons/facilities/wifi.png";
import IcCatering from "@/assets/2024/icons/facilities/catering.png";
import IcRestaurants from "@/assets/2024/icons/facilities/restaurants.png";
import IcWheelchair from "@/assets/2024/icons/facilities/wheelchair.png";

// Fungsi untuk membuat slug
const createSlug = (text) => {
    return text.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]+/g, '');
};

// Mendefinisikan fasilitas
export const facilities = () => {
    return [
        { label: 'Power', icon: IcPower, slug: createSlug('Power') },
        { label: 'Sound', icon: IcSound, slug: createSlug('Sound') },
        { label: 'Presentation Facilities', icon: IcPresentation, slug: createSlug('Presentation Facilities') },
        { label: 'Stage Floor Panel', icon: IcStageFloor, slug: createSlug('Stage Floor Panel') },
        { label: 'Free Parking Lot', icon: IcFreeParking, slug: createSlug('Free Parking Lot') },
        { label: 'Swimming Pool', icon: IcSwimmingPool, slug: createSlug('Swimming Pool') },
        { label: 'Gym', icon: IcGym, slug: createSlug('Gym') },
        { label: 'Parking Area', icon: IcFreeParking, slug: createSlug('Parking Area') },
        { label: 'Loading Area', icon: IcLoadingArea, slug: createSlug('Loading Area') },
        { label: 'Lobby', icon: IcLobby, slug: createSlug('Lobby') },
        { label: 'Wi-Fi', icon: IcWifi, slug: createSlug('Wi-Fi') },
        { label: 'Catering', icon: IcCatering, slug: createSlug('Catering') },
        { label: 'Restaurants', icon: IcRestaurants, slug: createSlug('Restaurants') },
        { label: 'Wheelchair Accessibility', icon: IcWheelchair, slug: createSlug('Wheelchair Accessibility') },
    ];
};